import React, { forwardRef } from 'react';

import { useGetStreams } from '@vlabs/api/artemy/client';
import { Checkbox } from '@vlabs/uikit/components/controls/checkbox';

import type { PopoverWithButtonProps } from '@vlabs/monokit/shared/ui/popovers';
import { PopoverWithButton } from '@vlabs/monokit/shared/ui/popovers';

import { useSourceFilters } from '../useSourceFilters';
import st from './popovers.module.sass';

// ponytail: опции — отдельный запрос всех потоков группы без пагинации (page_size 1000).
// Если потоков в группе станет больше 1000 — добавить подгрузку страниц.
const SOURCE_OPTIONS_PAGE_SIZE = 1000;

function SourceFilterPopover(
  {
    ...props
  }: PopoverWithButtonProps,
  ref: React.ForwardedRef<HTMLDivElement>,
) {
  const { filters, updateFilters } = useSourceFilters();
  const getStreams = useGetStreams({
    group_id: filters.group_id,
    enriched: 0,
    page: 1,
    page_size: SOURCE_OPTIONS_PAGE_SIZE,
  });

  const streams = getStreams.data?.streams ?? [];
  const selectedNames = filters.names ?? [];

  const onToggleSource = (name: string, checked: boolean) => {
    const nextNames = checked
      ? [...selectedNames, name]
      : selectedNames.filter((value) => value !== name);

    updateFilters({
      names: nextNames.length > 0 ? nextNames : undefined,
      page: 1,
    });
  };

  const reset = () => updateFilters({ names: undefined, page: 1 });

  return (
    <PopoverWithButton
      {...props}
      data-testid="stream-sources"
      onClickReset={reset}
      ref={ref}
    >
      <div className={st.OptionsList}>
        {streams.map((stream) => (
          <Checkbox
            checked={selectedNames.includes(stream.name ?? '')}
            key={stream.stream_id}
            label={stream.name}
            onChangeValue={(checked) => onToggleSource(stream.name ?? '', checked)}
          />
        ))}
      </div>
    </PopoverWithButton>
  );
}

export default forwardRef(SourceFilterPopover);
